var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrap},[_c('div',{staticClass:"opacitybg d-flex align-items-center"},[_c('span',{staticClass:"text-h6 font-weight-regular numberHolder"},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }